<template>
  <div class="pres_sumas conflex">
   
      <vtlabel style="flex:1 1 24%"
        label="Bases"
        :txt="pdat.base.value | num(2)"
        stilot="text-align:right"
      >
      </vtlabel>

      <vtlabel style="flex:1 1 24%"
        label="IVA"
        :txt="pdat.iva.value | num(2)"
        stilot="text-align:right"
      >
      </vtlabel>

      <vtlabel style="flex:1 1 24%"
        label="Suplidos"
        :txt="pdat.sup.value | num(2)"
        stilot="text-align:right"
      >
      </vtlabel>
      <vtlabel style="flex:1 1 24%"
        label="Total"
        :txt="pdat.imp.value | num(2)"
        stilot="font-weight:bold;text-align:right;color:#01579B"
              >
       </vtlabel>
    
  </div>
</template>

<script>
export default {
  props: {
    pdat: { type: Object, default: null },
    edicion: { type: Boolean, default: false }
  }
};
</script>
